import { AvatarGroup, Avatar } from '@chakra-ui/react'

export default function UserAvatar() {
    return (
        <AvatarGroup>
        <Avatar size='sm' bg='teal.500' />
    </AvatarGroup>  
    )
}